import {useEffect} from 'react'
import useTalkable from '../../hooks/use-talkable'

const TalkableScript = () => {
    const {getConfig} = useTalkable()
    const jsonConfig = getConfig()
    const available = jsonConfig && jsonConfig.enabled
    const scriptURL = jsonConfig ? jsonConfig.scriptURL : null
    const enabled = jsonConfig ? jsonConfig.enabled : false

    useEffect(() => {
        if (!available) return

        if (document.querySelector(`script[src="${jsonConfig.scriptURL}"]`)) {
            return
        }

        const script = document.createElement('script')
        script.src = jsonConfig.scriptURL
        script.defer = true
        script.async = true
        document.head.appendChild(script)
        return () => {
            document.head.removeChild(script)
        }
    }, [enabled, scriptURL])

    return null
}

export default TalkableScript
